import {RefineryStatusUnit} from '../../../../integrations/ong/classes/refinery-status-unit';

export class RefineryStatus {
    public facility_id;
    public name;
    public offline_capacity;
    public offline_units;
    public online_capacity;
    public online_units;
    public total_capacity;
    public total_units;
    public units: RefineryStatusUnit[];

    public status: 'Online' | 'Reduced Capacity' | 'Idled';
    public expanded: boolean = false;
    public refinery_alert_count: number = 0;
    public planned_outage_count: number = 0;
    public percent_impacted: number = 0;

    constructor(input?: RefineryStatus | any) {
        this.facility_id = input.facility_id;
        this.name = input.name;
        this.offline_capacity = input.offline_capacity;
        this.offline_units = input.offline_units;
        this.online_capacity = input.online_capacity;
        this.online_units = input.online_units;
        this.total_capacity = input.total_capacity;
        this.total_units = input.total_units;

        this.units = input.units?.map((unit) => RefineryStatusUnit.fromApi(unit));

        this.units?.forEach(u => {
            this.refinery_alert_count += u.alert_count;
            this.planned_outage_count += u.planned_outages;
        });

        // If Units is a undefined, it's coming from the consolidate report
        // Update API to just properly use a new updated API for this
        if (this.units === undefined) {
            this.refinery_alert_count = input.refinery_alert_count;
            this.planned_outage_count = input.planned_outage_count;

            this.total_capacity = input.capacity_at_end_date;
            this.offline_capacity = input.impacted_capacity_at_end_date;

            this.offline_units = input.units_offline;
            this.online_units = input.units_online;
        }

        this.percent_impacted = this.offline_capacity / this.total_capacity;

        if (this.online_units === this.total_units) {
            this.status = 'Online';
        } else if (this.online_units >= 1 && this.offline_units >= 1) {
            this.status = 'Reduced Capacity';
        } else if (this.offline_units === this.total_units) {
            this.status = 'Idled';
        }
    }
}
